export const figure70 = {
  chart: {
    type: 'column',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
},
colors: ['#a5a6a5','#ff0000','#204e79','#FFCC09','#92d04e','#385723',],
credits: {
    enabled: false
  },
  title: {
    text: null
  },
  subtitle: {
    text: null
  },
xAxis: {
    categories: ['Catégorie 1', 'Catégorie 2', 'Catégorie 3', 'Catégorie 4', 'Catégorie 5', 'Catégorie 6']
},
yAxis: {
    min: 0,
    title: {
        text: ''
    }
},
tooltip: {
    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
    shared: true
},
legend: {
    enabled: false,
  },
plotOptions: {
    column: {
        stacking: 'percent'
    }
},
series: [
  {
    name: 'Autre',
    data: [28.19, 30.35, 60.12, 24.83, 24.92, 21.29]
  },{
    name: 'Zone peuplée',
    data: [0, 0.06, 0.09, 0.13, 0.14, 0.22]
  },{
    name: 'Zone humide',
    data: [0.12, 0.16, 0.13, 0.13, 0.29, 0.56]
  }, {
    name: 'Terre cultivée',
    data: [3.15, 4.57, 5.87, 13.15, 9.69, 9.87]
},{
  name: 'Prairie',
  data: [67.92, 54.97, 19.52, 28.33, 21.84, 18.53]
},{
    name: 'Forêt',
    data: [0.62, 9.90, 14.28, 33.43, 43.13, 49.53]
},]
}